import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService, ConfigStateService } from '@abp/ng.core';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { EMPTY, timer } from 'rxjs';
import { catchError, filter, finalize, switchMap, take } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  template: ` <router-outlet></router-outlet> `,
})
export class AppComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private authStateRefreshInFlight = false;

  constructor(
    private authService: AuthService,
    private config: ConfigStateService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.config
      .getOne$('currentUser')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(currentUser => {
        if (this.authService.isAuthenticated && !currentUser?.isAuthenticated) {
          this.restoreAuthenticationState();
        }
      });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.restoreAuthenticationState());

    this.restoreAuthenticationState();
  }

  private restoreAuthenticationState(): void {
    if (this.authStateRefreshInFlight) {
      return;
    }

    const queryParams = new URLSearchParams(window.location.search);
    const isOidcCallback =
      queryParams.has('code') ||
      queryParams.has('state') ||
      queryParams.has('session_state');

    if (!isOidcCallback && !this.authService.isAuthenticated) {
      return;
    }

    this.authStateRefreshInFlight = true;

    timer(0, 250)
      .pipe(
        take(40),
        filter(() => this.authService.isAuthenticated),
        take(1),
        switchMap(() => this.config.refreshAppState()),
        catchError(() => EMPTY),
        finalize(() => {
          this.authStateRefreshInFlight = false;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
